<template>
  <div>
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="userRegularizationData === undefined">
      <h4 class="alert-heading">Error fetching user data</h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link class="alert-link" :to="{ name: 'regularizations' }">
          referral List
        </b-link>
      </div>
    </b-alert>

    <template v-if="userRegularizationData">
      <!-- First Row -->
      <b-row>
        <b-col cols="12" xl="12" lg="12" md="12">
          <regularization-view-info
            :user-data="userRegularizationData"
            :custom-fields="customFields"
          />
        </b-col>
      </b-row>
    </template>
    <template v-if="$can('Zircly Admin') || isReviewer">
      <!-- Second Row -->
      <b-row>
        <b-col cols="12" xl="12" lg="12" md="12">
          <b-card title="Review Leave Application">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Reviewer Reason"
                  label-for="reviewer_reason"
                >
                  <b-form-textarea
                    id="reviewer_reason"
                    v-model="userRegularizationData.reviewer_reason"
                    placeholder="Write Review for this application"
                    rows="3"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Application Status"
                  label-for="leave-status"
                >
                  <b-button
                    class="ml-5 mt-2"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    v-if="
                      userRegularizationData.status == '0' ||
                      userRegularizationData.status == '2'
                    "
                    @click="saveReview('Approved')"
                  >
                    Approve
                  </b-button>
                  <b-button
                    class="ml-5 mt-2"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="danger"
                    v-if="
                      userRegularizationData.status == '0' ||
                      userRegularizationData.status == '1'
                    "
                    @click="saveReview('Rejected')"
                  >
                    Reject
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "@vue/composition-api";
import {
  BRow,
  BCol,
  BAlert,
  BLink,
  BTabs,
  BTab,
  BCard,
  BCardText,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  VBTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import regularizationStoreModule from "../regularizationStoreModule";
import RegularizationViewInfo from "./RegularizationViewInfo.vue";
export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BTabs,
    BTab,
    BCard,
    BCardText,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    RegularizationViewInfo,
    VueGoodTable,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  setup() {
    const userRegularizationData = ref(null);
    const regularization = ref({
      name: "",
      id: "",
    });
    const USER_APP_STORE_MODULE_NAME = "app-regularizations";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(
        USER_APP_STORE_MODULE_NAME,
        regularizationStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    store
      .dispatch(
        "app-regularizations/fetchRegularization",
        router.currentRoute.params.id
      )
      .then((response) => {
        userRegularizationData.value = response.data.data;
        regularization.value.name = userRegularizationData.value.name;
        regularization.value.id = userRegularizationData.value.hashid;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          userRegularizationData.value = undefined;
        }
      });
    return {
      userRegularizationData,
      regularization,
    };
  },
  data() {
    return {
      userDataLocal: this.$cookies.get("userData"),
      pageLength: 3,
      regularizationChangeFlag: true,
      pageLengthEmployee: 3,
      dir: false,
      isAddNewInterviewSidebarActive: false,
      columns: [
        {
          label: "Interview Title",
          field: "title",
        },
        {
          label: "Start At",
          field: "start_at",
        },
        {
          label: "End At",
          field: "end_at",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      searchTerm: "",
      customFields: [],
    };
  },
  created() {
    this.getCustomFields();
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    isReviewer() {
      if (
        this.userRegularizationData &&
        this.userRegularizationData.reviewer.hashid ===
          this.userDataLocal.hashid
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    viewInterview(id) {
      this.$router.push(`/view/interview/${id}`).catch(() => {});
    },
    assignInterview() {
      console.log("assigning interview...");
      this.isAddNewInterviewSidebarActive = true;
    },
    refetchRegularizationsData() {
      console.log("refetching started..");
    },
    getCustomFields() {
      const self = this;
      self.$store
        .dispatch("app-regularizations/getCustomFields")
        .then((res) => {
          self.customFields = res.data.data;
        })
        .catch((error) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Custom Fields Getting Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: `Oops! Custom Fields Getting Failed`,
                icon:'ErrorIcon',
                variant : 'danger',
                hideClose: true,
                
              },
                  },
                  {
              timeout : 3000,
              position : 'bottom-center',
              toastClassName:"error-info",
              hideProgressBar : true,
                  })
        });
    },
    saveReview(status) {
      const self = this;
      const formData = new FormData();
      formData.append(
        "reviewer_reason",
        self.userRegularizationData.reviewer_reason
      );
      formData.append("hashid", self.userRegularizationData.hashid);
      formData.append("status", status);
      self.$store
        .dispatch("app-regularizations/saveReview", formData)
        .then((res) => {
          if (res.data.success) {
            // self.$router.push("/regularize-applications");
            self.$router.go(-1);
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Review saved successfully",
            //     icon: "BellIcon",
            //     variant: "success",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Review saved successfully',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
          } else {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Review Update Failed",
            //     icon: "BellIcon",
            //     variant: "danger",
            //     text: res.data.message,
            //   },
            // });

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Review Update Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
        })
        .catch((error) => {
          self.is_loading.submit = false;
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Holiday Adding Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: error,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Holiday Adding Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        });
    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    },
  },
};
</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<style lang="scss" scoped>
.add-btn {
  border: solid 1px;
  width: 70%;
}
.interview-pass {
  color: green;
}
.interview-fail {
  color: indianred;
}
</style>